import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactSelect from 'react-select';

import { getDefaultStyles } from './utils';
import HighlightedSearch from '../HighlightedSearch/HighlightedSearch';
import * as styles from './Select.scss';

/**
 * @class Select
 * @classdesc Reusable `react-select` Select Component Wrapper
 * @note Besides the bare essentials, this component serves as a styling wrapper.
 * @note Almost all `react-select` props are just passed explicitly down.
 * @note Exceptions: `formatOptionLabel`, `styles` (Default Styles Added), `onInputChange`
 * @see https://react-select.com/home
 * @see https://react-select.com/props
 * @property {Object} state
 */
export default class Select extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.any,
      }),
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    onInputChange: PropTypes.func,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    ),
    styles: PropTypes.objectOf(PropTypes.func),
  };

  static defaultProps = {
    className: null,
    onInputChange: () => {},
    style: null,
    styles: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
    };
  }

  /**
   * Input Event Change Listener for `react-select` component
   * @param {string} data
   * @return {Function}
   */
  onInputChange = data => {
    const { onInputChange } = this.props;

    this.setState({ searchValue: data });
    return onInputChange
      ? onInputChange(data)
      : null;
  };

  render() {
    const { className, style, styles: selectStyles } = this.props;
    const { searchValue } = this.state;
    const formatOptionLabel = (option) => <HighlightedSearch searchValue={searchValue} textValue={option.label} />;

    return (
      <div className={classNames(styles.select, className)} style={style}>
        <ReactSelect
          {...this.props}
          className={styles.reactSelect}
          onInputChange={this.onInputChange}
          formatOptionLabel={formatOptionLabel}
          styles={{ ...getDefaultStyles(), ...selectStyles }}
        />
      </div>
    );
  }
}
